import { get } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Accordion from '../../../../shared/components/Accordion';
import useScrollToHash from '../../../../shared/hooks/useScrollToHash';

const Questions = ({ offer }) => {
  useScrollToHash(120, 280);

  if (!offer) return null;
  const { t } = useTranslation();

  const faqs = useMemo(() => offer.faqs.map(faq => {
    if (faq.category === 'payment_details' && !get(offer, 'payments.length'))
      return null;
    if (faq.category === 'content_rights' && faq.code === "media_rights_instructions" && offer.hide_media_rights_price)
      return {
        ...faq,
        answer: offer.media_rights_influencer_instructions
      };
    return faq;
  }).filter(faq => faq), [offer.faqs]);

  const categories = useMemo(() => [...new Set(faqs.map(faq => (faq.category)))], [faqs]);

  const userOffer = offer.user_offer;

  const renderAccordion = (title, items) => {
    const collapsibles = items.map(item => ({
      header: item.question,
      content: <div
        dangerouslySetInnerHTML={{
          __html: item.answer
        }}></div>
    }));

    if (!collapsibles.length) return null;

    return (
      <Row className='mb-6'>
        <Col xs='12'>
          <h4 className='mb-4'>
            {title}
          </h4>
        </Col>
        <Col xs='12'>
          <Accordion collapsibles={collapsibles} />
        </Col>
      </Row>
    );
  };

  return (
    <div className='page'>
      <Container>
        <Row className={(!userOffer) ? "mb-sm-6" : ""}>
          <Col xs={12} sm={7}>
            <h3 className="mb-2 mb-sm-5">
              {t('influencers.pages.campaign.questions.title')}
            </h3>
          </Col>
        </Row>
        <Row>
          <Col sm='3' className="mb-6">
            <Row>
              {
                categories &&
                <Col xs={12} className="mb-2 px-0">
                  <nav id="navbar-components" className="navbar navbar-light bg-light">
                    <nav className="nav nav-pills flex-column">
                      {
                        categories.map(category => (
                          <a className="nav-link px-0" key={category} href={`#${category}`}>
                            {t(`influencers.pages.campaign.questions.categories.${category}`)}
                          </a>
                        ))
                      }
                    </nav>
                  </nav>
                </Col>
              }
            </Row>
          </Col>
          <Col sm={{
            offset: 1,
            span: 8
          }} >
            {
              categories.map(category => (
                <div key={category} className="text-1 scroll-margin-top-120" id={category}>
                  {renderAccordion(t(`influencers.pages.campaign.questions.categories.${category}`),
                    faqs.filter((faq) => faq.category == category))}
                </div>
              ))
            }
          </Col>
        </Row>
      </Container>
    </div>);
};

Questions.propTypes = {
  offer: PropTypes.any.isRequired
};

export default React.memo(Questions);

